module.exports = __webpack_public_path__ + "static/ibotta1-a5289de0dd93f623d644a23f29b389ce.png";